$(function() {
    $('.hide-green-border').find('.termek_box').each(function() {
        const a = $(this).find('.card-title').find('a');
        const new_name = $(a).text().replace(/^(.*?)( DoorOutlet(.*?))$/, '$1');
        
        $(a).text(new_name);
    });
});
